module.exports = __webpack_public_path__ + "img/cards.81317b3d.svg";